import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96eecd4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "template-collapse-trigger" }
const _hoisted_2 = { class: "template-collapse-title" }
const _hoisted_3 = { class: "box-arrow" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "app-collapse-content" }

export interface IProps {
    title: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null
  },
  setup(__props: any) {


  


return (_ctx: any,_cache: any) => {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!

  return (_openBlock(), _createBlock(_component_AppCollapse, null, {
    trigger: _withCtx(({ visible }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: _normalizeClass({ active: visible }),
            src: require('./images/icon-arrow-down.png')
          }, null, 10, _hoisted_4)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}
}

})